import { useButtonBack, useButtonNext } from 'components/Common/ImagesCarousel'
import { useEffect } from 'react'

export const KeyboardNavigation = () => {
  const { onClick: onBack, disabled: backDisabled } = useButtonBack()
  const { onClick: onNext, disabled: nextDisabled } = useButtonNext()

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'ArrowLeft' && !backDisabled) {
        event.preventDefault()
        onBack()
      }

      if (event.key === 'ArrowRight' && !nextDisabled) {
        event.preventDefault()
        onNext()
      }
    }

    window.addEventListener('keydown', onKeyDown)

    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [backDisabled, nextDisabled, onBack, onNext])

  return null
}
